import { useNavigate } from 'react-router-dom'

import { FinanceValueObjectsContactTypeEnum } from 'generated/resources/datatable.graphql'
import { ContactFragment } from 'generated/resources/graphql'

import Modal from 'modules/core/components/Modal'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import i18n from 'modules/core/lib/i18n'

import ContactQuickAddForm from './ContactQuickAddForm'

interface ContactQuickAddFormModalProps {
  onClose?: () => void
  contactType: FinanceValueObjectsContactTypeEnum
}

const ContactQuickAddFormModal = ({ onClose, contactType }: ContactQuickAddFormModalProps) => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()

  const handleSuccessAndRedirect = (contact: ContactFragment) => {
    onClose?.()
    navigate(navigation.finance.sales.clients.contactId.edit.fullPath({ contactId: contact.id }))
  }

  const title = i18n.t('finance.contacts.contact_form.new_contact.title')

  return (
    <Modal illustration="document-edit" title={title} onClose={onClose}>
      <ContactQuickAddForm
        contactType={contactType}
        onSuccessAndRedirect={handleSuccessAndRedirect}
      />
    </Modal>
  )
}

export default ContactQuickAddFormModal
